import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  width: "263.371",
  height: "238.535",
  viewBox: "0 0 263.371 238.535"
}
const _hoisted_2 = ["id"]
const _hoisted_3 = ["stop-color"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("stop", {
  offset: "1",
  "stop-color": "#fff"
}, null, -1)
const _hoisted_5 = ["id", "xlink:href"]
const _hoisted_6 = ["id"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("stop", {
  offset: "0",
  "stop-color": "#fff"
}, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("stop", {
  offset: "1",
  "stop-color": "#fff"
}, null, -1)
const _hoisted_9 = [
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = {
  id: "qiuqiu",
  transform: "translate(-36.5 -90)"
}
const _hoisted_11 = ["fill"]
const _hoisted_12 = ["fill"]
const _hoisted_13 = ["stroke"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("ellipse", {
  cx: "126.5",
  cy: "38.5",
  rx: "126.5",
  ry: "38.5",
  stroke: "none"
}, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("ellipse", {
  cx: "126.5",
  cy: "38.5",
  rx: "126",
  ry: "38",
  fill: "none"
}, null, -1)
const _hoisted_16 = [
  _hoisted_14,
  _hoisted_15
]
const _hoisted_17 = ["fill"]
const _hoisted_18 = ["fill"]
const _hoisted_19 = ["fill"]

import { withDefaults } from 'vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'survey-svg-3-1',
  props: {
    controlColor: { default: 'var(--theme-color-1,#000)' },
    numbers: { default: 1 }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("defs", null, [
      _createElementVNode("linearGradient", {
        id: `survey-svg-3-1-linear-gradient${_ctx.numbers}`,
        x1: "1.084",
        y1: "1.245",
        x2: "1.082",
        y2: "0.213",
        gradientUnits: "objectBoundingBox"
      }, [
        _createElementVNode("stop", {
          offset: "0",
          "stop-color": _ctx.controlColor
        }, null, 8, _hoisted_3),
        _hoisted_4
      ], 8, _hoisted_2),
      _createElementVNode("linearGradient", {
        id: `survey-svg-3-1-linear-gradient-2${_ctx.numbers}`,
        x1: "0.5",
        y1: "1",
        x2: "0.5",
        y2: "0",
        "xlink:href": `#survey-svg-3-1-linear-gradient${_ctx.numbers}`
      }, null, 8, _hoisted_5),
      _createElementVNode("linearGradient", {
        id: `survey-svg-3-1-linear-gradient-3${_ctx.numbers}`,
        x1: "0.5",
        x2: "0.5",
        y2: "1",
        gradientUnits: "objectBoundingBox"
      }, _hoisted_9, 8, _hoisted_6)
    ]),
    _createElementVNode("g", _hoisted_10, [
      _createElementVNode("path", {
        id: "联合_128",
        "data-name": "联合 128",
        d: "M4354.851,14005.862l11.847-11.844c19.354,4.826,46.467,7.83,76.486,7.83,27.771,0,53.052-2.571,72.008-6.774L4527.12,14007c-22.748,5.639-52.007,9.033-83.936,9.033C4409.162,14016.035,4378.165,14012.18,4354.851,14005.862Zm164.531-11.773c18.728-4.632,30.272-10.971,30.272-17.957,0-14.2-47.67-25.717-106.47-25.717-.208,0-.411,0-.619,0V13938h.619c72.452,0,131.188,17.465,131.188,39.013,0,11.471-16.645,21.784-43.139,28.925ZM4312,13977.015c0-21.123,56.436-38.32,126.906-38.992v12.414c-56.815.541-102.188,11.84-102.188,25.7,0,6.423,9.758,12.3,25.886,16.808l-11.784,11.78C4326.848,13997.652,4312,13987.849,4312,13977.015Z",
        transform: "translate(-4275 -13688)",
        stroke: "rgba(0,0,0,0)",
        "stroke-miterlimit": "10",
        "stroke-width": "1",
        fill: `url(#survey-svg-3-1-linear-gradient${_ctx.numbers})`
      }, null, 8, _hoisted_11),
      _createElementVNode("ellipse", {
        id: "椭圆_680",
        "data-name": "椭圆 680",
        cx: "110.5",
        cy: "33.5",
        rx: "110.5",
        ry: "33.5",
        transform: "translate(58 218)",
        fill: _ctx.controlColor,
        opacity: "0.126"
      }, null, 8, _hoisted_12),
      _createElementVNode("g", {
        id: "椭圆_681",
        "data-name": "椭圆 681",
        transform: "translate(42 213)",
        fill: "none",
        stroke: _ctx.controlColor,
        "stroke-width": "1",
        "stroke-dasharray": "6",
        opacity: "0.997"
      }, _hoisted_16, 8, _hoisted_13),
      _createElementVNode("path", {
        id: "路径_4784",
        "data-name": "路径 4784",
        d: "M186.1,251.247c-26.757,0-51.918-2.541-70.85-7.155-19.161-4.67-29.712-10.98-29.712-17.77s10.552-13.1,29.712-17.77c18.931-4.614,44.093-7.155,70.85-7.155s51.918,2.541,70.849,7.155c19.161,4.67,29.713,10.98,29.713,17.77s-10.552,13.1-29.713,17.77C238.022,248.706,212.86,251.247,186.1,251.247Zm0-48.748c-26.672,0-51.741,2.53-70.589,7.124-18.349,4.471-28.873,10.558-28.873,16.7s10.524,12.228,28.873,16.7c18.848,4.594,43.917,7.124,70.589,7.124s51.74-2.53,70.589-7.124c18.349-4.471,28.873-10.559,28.873-16.7s-10.524-12.228-28.873-16.7C237.843,205.029,212.774,202.5,186.1,202.5Z",
        transform: "translate(-17.541 -13.323)",
        fill: `url(#survey-svg-3-1-linear-gradient-2${_ctx.numbers})`
      }, null, 8, _hoisted_17),
      _createElementVNode("circle", {
        id: "椭圆_682",
        "data-name": "椭圆 682",
        cx: "69",
        cy: "69",
        r: "69",
        transform: "translate(99 90)",
        fill: _ctx.controlColor
      }, null, 8, _hoisted_18),
      _createElementVNode("ellipse", {
        id: "椭圆_683",
        "data-name": "椭圆 683",
        cx: "54.86",
        cy: "39.43",
        rx: "54.86",
        ry: "39.43",
        transform: "translate(113 94)",
        opacity: "0.263",
        fill: `url(#survey-svg-3-1-linear-gradient-3${_ctx.numbers})`
      }, null, 8, _hoisted_19)
    ])
  ]))
}
}

})